import { createBrowserRouter, Navigate } from 'react-router-dom'

import GachaPage from '@/pages/gacha/page'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/gacha" replace />,
  },
  {
    path: '/gacha',
    element: <GachaPage />,
  },
  {
    path: '*',
    element: <Navigate to="/gacha" replace />,
  },
])

export default router
